"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteTextTopic = exports.WaysteTextTopics = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.WaysteTextTopics = ['WAYSTE-DRIVER-ENROUTE-DELIVERY', 'WAYSTE-DRIVER-ENROUTE-REMOVAL'];
exports.WaysteTextTopic = typebox_1.Type.Union(exports.WaysteTextTopics.map((topic) => typebox_1.Type.Literal(topic)));
//# sourceMappingURL=wayste-text-topics.js.map